<template lang="">
    <v-app> 
         <Tabs :routes='route' colors="#7414bf"/>
            <v-container>
                <transition name="slide-fade">
                 <router-view></router-view>
                </transition>
            </v-container>
    </v-app>
</template>
<script>

import Tabs from '../../component/layouts/content/tabs'

export default {
    
    components:{
        Tabs
    },

    data(){

        return {


            route:[
                //{
             //       id:1,
              //      name:'Configuraciones',
               //     icon:'mdi-settings-box',
                  //  route:'/config',
                  //  items: [
                  //      {
                   //     text: 'Inicio',
                    //    disabled: false,
                    //    href: '/',
                    //    },
                    //    {
                    //    text: 'Configuracion',
                    //    disabled: true,
                    //    href: 'asignacion',
                    //    },
                        
                  //  ],
                
              //  },

              

                
            ]

        }
        
    }


}
</script>